import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { MenuType } from "../../../redux/userManagement/userManagementTypes";
import { TableHeader } from "../../commons";
import NestedTables from "./NestedTables";
import NormalTable from "./NormalTable";


type AppProps = {
  data: MenuType[] ;
  headers: TableHeadersType[];
  fetching: boolean;
  isEditMenuListPresent: boolean;
  handleEditMenuDetails: (data: any) => void;
};

const UserManagementTable = ({
  data,
  headers,
  handleEditMenuDetails,
  isEditMenuListPresent
}: AppProps) => {
  const renderList = () => {
    let finalList =
      data?.length > 0 &&
      data?.map((MenuDetail: any) => {
        if (MenuDetail?.sub_menu.length == 0) {
          return (
            <NormalTable
              menuDetails={MenuDetail}
              handleEditMenuDetails={handleEditMenuDetails}
              headers={headers}
              isEditMenuListPresent={isEditMenuListPresent}
            />
          );
        }
       else if (MenuDetail?.sub_menu.length >0) {
          return (
            <>
              <NestedTables
                menuDetails={MenuDetail}
                handleEditMenuDetails={handleEditMenuDetails}
                indentation={0.7}
                parent={""}
                isEditMenuListPresent={isEditMenuListPresent}
              />
            </>
          );
        }
      });

    return finalList;
  };

  return (
    <>
      <div className="row" >
        <div className="col-md-12">
          <div className="table-bordered" >
            <table className="table table-striped" >
              <thead>
                <TableHeader tableHeader={headers} extraHeader textCenter />
              </thead>
              <tbody>
                {renderList()}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserManagementTable;
